import DateMixin from '@/shared/mixins/date.mixin'
import AuthMixin from '@/shared/mixins/auth.mixin'
import ExamObservation from '@/shared/mixins/exam-observation.mixin'
import CONSTANTS from '../../../../shared/constants/constants'

export default {
  name: 'exam-details-observation',
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  mixins: [
    DateMixin,
    AuthMixin,
    ExamObservation
  ],
  data () {
    return {
      newObservation: null,
      STATUS: CONSTANTS.STATUS,
      creationDate: null,
      modelEmergency: false,
      isConfirmedOpened: true
    }
  },

  computed: {
    isSubheaderTextareaVisible() {
      return !this.isConfirmedOpened && !this.details.emergency && this.details.observations.length === 0
    },
    hasAddObservation() {
      if (this.isSubheaderTextareaVisible) {
        return false
      }

      if (!this.details.observations || !this.details.observations.length) {
        return true
      }

      return !(this.details.observations.length || this.details.originalStatus.id === this.STATUS.LAUDO_LIBERADO)
    },
        observation() {
      if (!this.details.observations || !this.details.observations.length) {
        return {
          content: '',
          nameUser: '',
          creationDate: null
        }
      }

      const observation = this.details.observations[0]
      this.creationDate = this.getFormattedDateHourMinSec(observation.creationDate)
      return observation
    }
  },
  mounted() {
    this.$root.$on('updateModelEmergency', (data) => this.updateModelEmergency(data))
    this.$root.$on('updateIsConfirmedOpened', (data) => this.updateIsConfirmedOpened(data))
  },
  methods: {
    updateModelEmergency(modelEmergency) {
      this.modelEmergency = modelEmergency
    },
    updateIsConfirmedOpened(isConfirmedOpened) {
      this.isConfirmedOpened = isConfirmedOpened
    },
    async addObservation () {
      const observation = {
        content: this.newObservation,
        examId: this.details.examId,
        creationDate: this.getToday(),
        nameUser: this.getFullName()
      }

      this.$root.$emit('showLoading')
      try {
        const result = await this.addExamObservation(observation)
        const statusId = result.data.data.status.id
        this.details.observations = [observation]
        this.newObservation = null
        this.$emit('addObservation', statusId)
      } finally {
        this.$root.$emit('hideLoading')
      }
    }
  }
}
